/// <reference path="appbase.ts" />
/// <reference path="app_settings.ts" />


namespace TerminalApp {



    //packaging cache
    let packagings: SP.PackagingInfo[];

    export class WeightController {
        outer = document.createElement("div");
        container = document.createElement("div");
        headline = document.createElement("div");
        submit_button = document.createElement("div");
        close_button = document.createElement("div");
        items: WeighItem[] = [];
        constructor() {
            container.appendChild(this.outer);
            this.outer.classList.add("full_forground", "weight_controller_wrapper");
            this.outer.appendChild(this.container);

            this.close_button.classList.add("close");
            this.close_button.innerHTML = `<i class="far fa-window-close"></i>`;
            this.outer.appendChild(this.close_button);

            this.container.append(this.headline);
            this.headline.classList.add("headline");
            this.headline.innerHTML = SP.Localize("sentance_weigh_items");
            this.container.classList.add("weight_controller");

            this.submit_button.classList.add("submit", "grad-green");
            this.submit_button.innerHTML = SP.Localize("word_update");

            this.submit_button.addEventListener("click", () => {
                this.submit();
            });


            this.close_button.addEventListener("click", () => {
                this.close();
            });

            this.close();
        }

        clear() {
            this.items.forEach(itm => {
                itm.container.remove();
            });
            this.items = [];
        }

        callback: () => void;

        load(shipment: SP.ShipmentInfo, onlyZero: boolean, callback: () => void) {
            this.clear();
            for (let i = 0; i < shipment.lines.length; i++) {
                let info = shipment.lines[i].orderLine.itemInfo;
                let w = info.warehouseWeight > 0 ? info.warehouseWeight : info.weight;
                if (onlyZero && w > 0) continue;

                let item = new WeighItem(info);
                this.container.appendChild(item.container);
                this.items.push(item);
            }
            this.container.appendChild(this.submit_button);
            this.container.style.height = (shipment.lines.length * 65 + 130) + "px";
            this.callback = callback;
            if (this.items.length) {
                this.outer.style.display = "block";
            }
        }

        async submit() {
            let data: any = {};
            this.items.forEach(itm => {
                let weight = itm.item.weight = itm.item.warehouseWeight = parseInt(itm.input.value);
                data[itm.item.id] = itm.item.weight;
            });

            let result = await SP.post<any>("/api/v1/item/updateweight", data);

            if (result.status == 200) {
                this.close();
                if (this.callback) this.callback();
            }
            else {
                SP.alertX(`${result.status}: ${result.msg}`)
                console.log(result);
            }
        }

        close() {
            this.outer.style.display = "none";

        }
    }

    export class App_Pack_Order extends AppBase {
        static Instance: App_Pack_Order;
        tote: SP.ToteInfo = null;
        currentShipment: SP.ShipmentInfo = null;
        currentCustomer: SP.CustomerInfo = null;
        po_order_info = document.getElementById("po_order_info");
        po_tote_info = document.getElementById("po_tote_info");
        po_tote_name = document.getElementById("po_tote_name");
        po_order_items = document.getElementById("po_order_items");
        po_weight_button = document.getElementById("po_weight_button");
        po_print_note_button = document.getElementById("po_print_note_button");
        po_notification_button = document.getElementById("po_notification_button");
        po_packages = document.getElementById("po_packages");
        po_order_create_container = document.createElement("div");
        po_order_finish_cancel = document.getElementById("po_order_finish_cancel");
        po_order_finish = document.getElementById("po_order_finish");
        po_order_cancel = document.getElementById("po_order_cancel");
        po_status = document.getElementById("po_status");
        po_status_value = document.getElementById("po_status_value");

        auto_weight: SP.CheckboxDoodle;
        order_items: { [key: string]: OrderItem } = {};
        packages: Package[] = [];
        activePackage: Package = null;
        bound = false;
        weight_controller = new WeightController();

        constructor() {
            super("app_pack_order");
            App_Pack_Order.Instance = this;
            this.po_order_create_container.classList.add("order_create_container");

            //add package button
            var add_package_button = this.po_order_create_container.appendChild(document.createElement("div"));
            add_package_button.addEventListener("click", () => {

                var p = this.addPackage();
                p.calculateMetrics();
                p.save(true);
            });
            add_package_button.classList.add("add_package_button");
            add_package_button.innerHTML = "<i class='fas fa-plus'></i>";

            this.po_packages.appendChild(this.po_order_create_container);
            this.auto_weight = new SP.CheckboxDoodle(document.getElementById("po_auto_weight") as HTMLInputElement);


            this.po_order_finish_cancel.addEventListener("click", () => {
                this.cancelAutoFinish();
            });

            
            this.po_order_cancel.addEventListener("click", async () => {
                if (!await SP.confirmX("CANCEL PACKING?")) return;
                this.cancelOrder();

            });

            this.po_order_finish.addEventListener("click", () => {
                this.finishOrder();

            });

            this.po_print_note_button.addEventListener("click", () => {
                this.printDeliveryNote(false);
            });

            this.po_notification_button.addEventListener("click", () => {
                this.showWarehouseNotification();
            });

            new SP.Droppable(this.po_order_items, ["packageItem"], async (type, d) => {
                if (type == "packageItem") {
                    let item = d as PackageItem;
                    await item.parent.addItem(item.item, item.order_line_id, -1);
                    App_Pack_Order.Instance.updateCounts();
                }
            });


            new SP.Droppable(this.po_order_create_container, ["packageItem", "orderItem"], async (type, d) => {
                if (type == "packageItem") {
                    let item = d as PackageItem;
                    let nPackage = this.addPackage();
                    nPackage.carrier_dropdown.value = item.parent.carrier_dropdown.value;
                    await item.parent.addItem(item.item, item.order_line_id, - 1);
                    await nPackage.addItem(item.item, item.order_line_id, 1);
                    App_Pack_Order.Instance.updateCounts();
                }


                if (type == "orderItem") {
                    let item = d as PackageItem;
                    let nPackage = this.addPackage();
                    await nPackage.addItem(item.item, item.order_line_id, 1);
                    App_Pack_Order.Instance.updateCounts();
                }

            });





            this.po_weight_button.addEventListener("click", () => {
                if (this.currentShipment)
                    this.weight_controller.load(this.currentShipment, false, () => { this.updateMetrics(); });

            });
        }

    
        readyCheck() {
            var ready = true;
            this.po_order_finish.style.display = "none";

            if (this.currentShipment == null) return false;

            //all items in pack
            for (let key in this.order_items) {
                var item = this.order_items[key];
                if (item.packed_qty != item.max_qty) {
                    ready = false
                    break;
                }
            }

            //all packages printed
            for (let i = 0; i < this.packages.length; i++) {
                let item = this.packages[i];
                if (!item.trackingNumber) {
                    ready = false;
                    break;
                }
            }

            if (ready) {
                this.po_order_finish.style.display = "block";
                this.startFinishCountDown();
            }

            return ready;
        }


        autoFinish = false;
        async startFinishCountDown() {
            if (this.autoFinish) return;

            this.po_order_finish_cancel.style.display = "block";
            this.autoFinish = true;

            for (var i = 5; i > 0; i--) {
                document.getElementById("po_cancel_cooldown").innerHTML = i.toString();
                console.log("start cooldown", i);


                await SP.sleep(1000);

                if (!this.autoFinish || !this.allPacked) break;

                if (i == 1) {
                    this.finishOrder();
                    this.autoFinish = false;
                }
            }
            this.po_order_finish_cancel.style.display = "none";


        }

        async printDeliveryNote(save: boolean) {
            this.po_print_note_button.classList.add("disabled");
            if (!App_Settings.terminalSettings.label_printer) {
                return SP.alertX(SP.Localize("sentance_please_select_printer"));
            }

            var result = await SP.post<any>("/api/v1/shipment/printnote/" + this.currentShipment.shipmentId,
                {
                    label_printer: App_Settings.terminalSettings.label_printer,
                    etiquette_printer: App_Settings.terminalSettings.etiquette_printer,
                    a4_printer: App_Settings.terminalSettings.a4_printer,
                    saveShipmentTemplate: save
                });
            console.log("print result", result);
            if (result.status != 200) {
                await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
            }
            this.po_print_note_button.classList.remove("disabled");
        }

        cancelAutoFinish() {
            this.autoFinish = false;
            this.po_order_finish_cancel.style.display = "none";
        }

        async finishOrder() {
            let result = await SP.get<any>("/api/v1/shipment/finish/" + this.currentShipment.shipmentId);
            if (result.status == 200) {
                SP.Sounds.Success.play();
                SP.setAllHash({ "app": "app_pack_tote_list" });
            }
            else await SP.alertX(result.status + ": " + result.msg);
        }


        async cancelOrder() {

            StartLoading();
            let data = {
                shipmentId: this.currentShipment.shipmentId,
                force: true
            }

            let result = await SP.post<any>("/API/v1/PickList/moveShipment/", data);
            if (result.status == 200) {
                SP.Sounds.Success.play();
                SP.setAllHash({ "app": "app_pack_tote_list" });
            }
            else {
                await SP.alertX("Error " + result.status + ": " + result.msg);
            }
            StopLoading();



        }


        async onOpen() {
            this.reset();

            //preload packagings
            if (packagings == null) packagings = await SP.Data.Packaging.getPackagingInfos();


            //bind events and groups
            console.log("OPEN");
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on(null, this.scanBarcode, this);
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on("print", this.scanPrinter, this);
                document.addEventListener("keydown", this.inputListener);
            }

            var toteId = SP.getHash("tote");
            var bc = SP.getHash("barcode");
            if (toteId) this.loadTote(toteId, bc);


        }

        async onClose() {
            if (this.bound) {
                this.bound = false;
                barcodeListener.off(null, this.scanBarcode);
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off("print", this.scanPrinter);
                document.removeEventListener("keydown", this.inputListener);
                if (this.tote) {
                    await hub.connection.invoke<boolean>("releaseTote", this.tote.toteId);
                }
            }
            this.reset();
        }

        spaceTime: number;
        spacePrintTime: number;
        async inputListener(e: KeyboardEvent) {
            var _this = App_Pack_Order.Instance;
            if (e.which == 32) {

                if (document.activeElement instanceof HTMLInputElement)
                    return;

                var now = performance.now();
                var dif = now - _this.spaceTime;

                if (dif <= 1000) {

                    //prevent spam if space is kept down!
                    if (performance.now() - _this.spacePrintTime < 1000) {
                        _this.spacePrintTime = performance.now();

                        return;
                    }


                    _this.spaceTime = 0;
                    _this.spacePrintTime = performance.now();
                    _this.printAllLabels();
                }
                _this.spaceTime = now;
            }
        }

        async printAllLabels() {
            //print all labels
            for (let i = 0; i < this.packages.length; i++) {
                var pack = this.packages[i];
                await pack.printLabel();

            }
        }

        reset() {
            this.activePackage = null;
            this.packages = [];
            this.order_items = {};
            this.autoFinish = false;
            this.currentCustomer = null;
            this.currentShipment = null;
            this.tote = null;
            this.po_packages.innerHTML = "";
            this.po_order_items.innerHTML = "";
            this.po_tote_info.style.backgroundColor = "";
            this.po_tote_name.innerHTML = "";
            this.po_order_finish.style.display = "none";
            this.po_order_finish_cancel.style.display = "none";


        }

        async loadTote(id: string, barcodeScan: string = "") {
            

            //already active tote
            if (this.tote != null) return await SP.alertX("finish current tote first!");
            var canLockToMe = await hub.connection.invoke<boolean>("lockTote", parseInt(id));

            //check that tote is locked to us
            if (!canLockToMe) {
                if (!await SP.confirmX("tote is not locked to you! do you want to force open it?")) {
                    TerminalApp.GetApp("app_pack_tote_list").open();
                    return;
                }
            }

            //get tote info
            var tote = await SP.Data.Tote.getToteInfo(id, false);

            //check if ready
            if (!tote.readyForPack) {
                return SP.alertX("tote not ready for packing!");
            }

            this.tote = tote;

            //update customer and customer
            this.currentShipment = await SP.Data.Shipment.getShipmentInfo(this.tote.shipmentId);
            this.currentCustomer = await SP.Data.Customer.getCustomerInfo(this.currentShipment.order.customerId);

            //remove finished packages
            for (let i = this.currentShipment.packages.length - 1; i >= 0; i--) {
                if (this.currentShipment.packages[i].state == SP.PackageState.Packed)
                    this.currentShipment.packages.splice(i, 1);
            }

            if (SP.getHash("tote") != id) {
                ignoreHashChange = true;
                SP.setHash("tote", id);
            }



            this.updateToteInfo();
            this.updateOrderInfo();

            //this.po_order_info.innerHTML = `<b>${this.currentCustomer.customerName}</b><br />
            //                                   <b><a target="_blank" href="/admin/customers/orders/form?id=${this.currentShipment.order.customerId}&orderid=${this.currentShipment.order.orderId}">${this.currentShipment.order.orderNo}</a></b> ${this.currentShipment.order.recipient.name}<br />
            //                                    ${this.currentShipment.order.deliveryMethodInfo.name}`

            this.po_order_info.innerHTML = `<b>${this.currentCustomer.customerName}</b><br />
                                               <b><a href="/terminal/#app=app_order_info&orderId=${this.currentShipment.order.orderId}">${this.currentShipment.order.orderNo}</a></b> ${this.currentShipment.order.recipient.name}<br />
                                                ${this.currentShipment.order.deliveryMethodInfo.name}`

            if (this.currentShipment.order.deliveryMethodInfo.warehouseNotificationPacker) {
                new SP.DismissInfo("Delivery Method Notification", this.currentShipment.order.deliveryMethodInfo.warehouseNotificationPacker);
            }

            //adding a package if none
            var autofill = App_Settings.userSettings.allow_autofill_package && (this.tote.pickSettings?.autofillPackageFromTote ?? true);


            if (!tote.groupPick && !barcodeScan.length && autofill && !this.currentShipment.packages.length) {
                var package1 = this.addPackage();


                let auto_pick_qty: { [key: string]: number } = {};
                for (let i = 0; i < this.tote.picks.length; i++) {
                    let pick = this.tote.picks[i];
                    auto_pick_qty[pick.orderLineId] = (auto_pick_qty[pick.orderLineId] ?? 0) + pick.qty;
                }

                for (let key in auto_pick_qty) {
                    let item = this.order_items[key];
                    package1.addItem(item.item, item.order_line_id, auto_pick_qty[key], false);
                }

                package1.calculateMetrics();
                package1.save(true);
            }
                

            else {
                for (let i = 0; i < this.currentShipment.packages.length; i++) {
                    let data = this.currentShipment.packages[i];
                    let p = this.addPackage();
                    p.load(data, this.currentShipment);
                    p.calculateMetrics();
                }
            }


            if (this.auto_weight.checked)
                this.weight_controller.load(this.currentShipment, true, () => { this.updateMetrics(); });

          
           

            if (this.currentShipment.order.warehouseNotificationPacker) {
                this.showWarehouseNotification();
                this.po_notification_button.style.display = "block";
            }
            else {
                this.po_notification_button.style.display = "none";
            }



            this.updateCounts();
            this.readyCheck();

            //Scan Barcode
            if (!this.currentShipment.packages.length && barcodeScan.length) this.scanBarcode(barcodeScan);


            //Print Deliverynote
            if (App_Settings.userSettings.print_delivery_instantly && (
                this.currentShipment.order.printDeliveryNote
                || (this.tote.pickSettings?.forceDeliveryNote ?? false)
                || (this.currentShipment.order.deliveryMethodInfo?.forceDeliveryNote ?? false))) {
                this.printDeliveryNote(false)
            }

            this.po_packages.appendChild(this.po_order_create_container);
        }

        showWarehouseNotification() {
            new SP.DismissInfo("Warehouse Notification (OrderNo: " + this.currentShipment.order.orderNo + ")", this.currentShipment.order.warehouseNotificationPacker);
            SP.alertX("");
        }

        addPackage() {
            var p = new Package(this.currentShipment, this.currentCustomer, this.tote);
            this.po_packages.appendChild(p.container);
            this.po_packages.appendChild(this.po_order_create_container);

            this.packages.push(p);
            this.activePackage = p;

            p.updateParcelTypes(true);

            return p;
        }

        async removePackage(p: Package) {
            p.container.style.display = "none";
            let result = await SP.get<any>("/api/v1/package/delete/" + p.id);
            if (result.status == 200) {
                var index = this.packages.indexOf(p);
                if (index != -1) {
                    p.container.remove();
                    this.packages.splice(index, 1);
                }
                if (this.activePackage == p) {
                    this.activePackage = this.packages[this.packages.length - 1];
                }

                this.updateCounts();
                console.log("package removed");

            }
            else {
                p.container.style.display = "block";
                await SP.alertX(result.status + ": " + result.msg);
                console.log(result);
            }
        }


        async scanBarcode(barcode: string) {

            //Add Item
            for (let key in this.order_items) {
                let item = this.order_items[key];
                for (let code in item.item.allBarcodes) {
                    if (code.includes(barcode) || barcode.includes(code)) {
                        if (item.packed_qty < item.max_qty) {
                            var p = this.getLastPackage();
                            var qty = GetBarcodeQty(item.item.allBarcodes, code);
                            p.addItem(item.item, item.order_line_id, qty ? qty : 1, true);
                            this.updateCounts();
                            SP.Sounds.Success.play();

                            return;
                        }
                    }
                }
            }

            var packaging = packagings.filter(p => p.barcode.indexOf(barcode) != -1)[0];
            if (packaging != null) {
                this.setPackaging(packaging);
                return;
            }
            SP.Sounds.Error.play();
        }



        lastPrintScan: number = 0;
        async scanTote(toteId: string) {

            if (toteId == this.tote.toteId.toString()) {
                if (SP.ActiveNotifications.length) return SP.Sounds.Error.play();
                var now = performance.now();
                if (App_Settings.userSettings.auto_double_scan_print_label || now - this.lastPrintScan < 500) {
                    return this.printAllLabels();
                }
                this.lastPrintScan = now;
                return;
            }
            else {
                this.lastPrintScan = 0;
                if (this.autoFinish) {
                    Talk("word_wait");
                    return;
                }

                //get tote info
                var tote = await SP.Data.Tote.getToteInfo(toteId, false);

                //check if ready
                if (!tote.readyForPack) return SP.Sounds.Error.play();
                SP.setAllHash({ "app": "app_pack_order", "tote": toteId });
            }
        }

        async scanPrinter(printerName: string) {
            if (SP.ActiveNotifications.length) return SP.Sounds.Error.play();
            selectPrinter(printerName);
            var now = performance.now();
            if (App_Settings.userSettings.auto_double_scan_print_label || now - this.lastPrintScan < 500) return this.printAllLabels();
            this.lastPrintScan = now;
        }

        getLastPackage() {
            var p = this.packages[this.packages.length - 1];

            if (p == null || p.trackingNumber) p = this.addPackage();
            return p;
        }

        setPackaging(packaging: SP.PackagingInfo) {
            if (this.activePackage == null)
                this.activePackage = this.addPackage();
            this.activePackage.setPackaging(packaging.id, true);
        }

        updateMetrics() {
            this.packages.forEach(p => {
                p.calculateMetrics();
            });
        }


        updateToteInfo() {
            var t = this.tote;
            this.po_tote_info.style.backgroundColor = t.toteColor;
            this.po_tote_name.innerHTML = t.toteName;
        }

        updateOrderInfo() {
            this.po_order_items.innerHTML = "";

            for (let i = 0; i < this.currentShipment.lines.length; i++) {
                var sl = this.currentShipment.lines[i];
                let item = new OrderItem(sl);
                this.order_items[sl.orderLine.id] = item;
                this.po_order_items.appendChild(item.container);
            }
        }

        allPacked: boolean = false;
        totalItems: number;
        packedItems: number;
        updateCounts() {
            this.totalItems = 0;
            this.packedItems = 0;

            for (let key in this.order_items) {
                var item = this.order_items[key];
                item.packed_qty = 0;


                for (let s = 0; s < this.packages.length; s++) {
                    let p = this.packages[s];

                    for (let key in p.items) {
                        let packageItem = p.items[key];
                            console.log("Update Counts", packageItem, item);
                        if (packageItem.order_line_id == item.order_line_id) {
                            item.packed_qty += packageItem.qty;
                        }
                    }
                }

                this.totalItems += item.max_qty;
                this.packedItems += item.packed_qty;
                item.update();
            }

            let show = this.totalItems != this.packedItems;
            this.allPacked = !show;
            this.po_status.style.display = show ? "block" : "none";
            this.po_order_items.style.bottom = show ? "194px" : "53px";
            this.po_status_value.innerHTML = this.packedItems + " / " + this.totalItems;
            this.readyCheck();
        }



    }


    export class Messurement {
        container = document.createElement("div");
        input = document.createElement("input");

        constructor(icon: string, text: string, unit: string) {
            this.container.innerHTML += "<img src='" + icon + "' />";
            this.container.innerHTML += "<span class='text'>" + text + "</span>";
            this.container.innerHTML += "<span class='unit'>" + unit + "</span>";
            this.container.classList.add("messurement");
            this.input.type = "number";
            this.container.appendChild(this.input);
        }
    }

    export class Package {
        container = document.createElement("div");
        contents = document.createElement("div");
        deliveryInstructions = document.createElement("input");
        orderNo = document.createElement("input");
        referenceNo = document.createElement("input");
        print_button = document.createElement("div");
        print_note_button = document.createElement("div");
        label_info = document.createElement("div");
        remove_button = document.createElement("div");
        messurement_length = new Messurement("/terminal/img/icon/pack_width.png", SP.Localize("word_length"), "mm");
        messurement_height = new Messurement("/terminal/img/icon/pack_height.png", SP.Localize("word_height"), "mm");
        messurement_width = new Messurement("/terminal/img/icon/pack_debth.png", SP.Localize("word_width"), "mm");
        messurement_weight = new Messurement("/terminal/img/icon/pack_weight.png", SP.Localize("word_weight"), "g");
        parcel_type_dropdown: SP.DropDown;
        carrier_dropdown: SP.DropDown;
        packaging_dropdown: SP.DropDown;
        packaging: SP.PackagingInfo = null;
        shipment: SP.ShipmentInfo;
        customer: SP.CustomerInfo;
        toteInfo: SP.ToteInfo;

        items: { [line_id: string]: PackageItem } = {};

        //data
        id: string;
        deliveryMethodId: string = null;
        parcelType: string = null;
        trackingNumber: string = null;
        width: number = 0;
        length: number = 0;
        height: number = 0;
        weight: number = 0;
        before_width: number = 0;
        before_length: number = 0;
        before_height: number = 0;
        before_weight: number = 0;
        selectedDeliveryMethod: SP.DeliveryMethod;

        load(pi: SP.PackageInfo, s: SP.ShipmentInfo) {
            console.log("LOADING", pi, s);
            for (let i = 0; i < pi.lines.length; i++) {
                let l = pi.lines[i];
                let sl = s.lines.filter(x => x.orderLine.id == l.orderLineId)[0];
                try {
                    this.addItem(sl.orderLine.itemInfo, sl.orderLine.id, l.quantity, false);
                } catch (error) {
                    console.log(error);
                }
            }

            this.id = pi.id;
            this.setPackaging(pi.packagingId, false);
            this.setDeliveryMethod(pi.deliveryMethodId, false);
            console.log("SETTING PARCEL TYPES FOR DM:" + this.deliveryMethodId + " to " + pi.parcelType);

            
            if (this.selectedDeliveryMethod.parcelTypes.filter(p => p.code == pi.parcelType))
                this.setParcelType(pi.parcelType, false);
            else
                this.setParcelType(null, false);

            this.deliveryInstructions.value = pi.deliveryInstructions;
            this.orderNo.value = pi.orderNo;
            this.referenceNo.value = pi.referenceNo;
            this.trackingNumber = pi.trackingNumber;
            this.before_width = this.width = pi.width;
            this.before_height = this.height = pi.height;
            this.before_weight = this.weight = pi.weight;
            this.before_length = this.length = pi.length;
            this.renderInputData();
            this.updateDeliveryMethods();
            this.updateLabelInfo();

            if (this.trackingNumber) 
                this.print_button.classList.add("btn_disabled_effect");
            
        }

        constructor(shipment: SP.ShipmentInfo, customer: SP.CustomerInfo, t: SP.ToteInfo) {
            this.shipment = shipment;
            this.customer = customer;
            this.toteInfo = t;

            this.container.classList.add("order");

            //set deliverymethod from order
            this.deliveryMethodId = shipment.order.deliveryMethodInfo.id;
            var method = this.customer.deliveryMethods[this.deliveryMethodId];
            if (!method) method = this.customer.deliveryMethods["none"];

            //set default parceltype if none
            console.log("Method", method, this.deliveryMethodId, this.customer.deliveryMethods);



            this.parcelType = method == null ? "" : method.parcelTypes.filter(pt => pt.enabled)[0]?.code ?? null;
            this.remove_button.innerHTML = "<i class='fas fa-trash'></i>";
            this.remove_button.classList.add("cancel-button");

            this.remove_button.addEventListener("click", async () => {
                await App_Pack_Order.Instance.removePackage(this)
            });

            this.container.appendChild(this.remove_button);
            this.container.appendChild(this.messurement_length.container);
            this.container.appendChild(this.messurement_height.container);
            this.container.appendChild(this.messurement_width.container);
            this.container.appendChild(this.messurement_weight.container);


            var enterSubmit = (e: KeyboardEvent) => {
                if (e.keyCode == 13) {
                    SP.blurActive();
                }
            };

            var saveMetrics = () => {
                this.saveMetricsFromInputs();
                this.updateDeliveryMethods();
                this.save(false);
            };

            this.messurement_length.input.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.messurement_height.input.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.messurement_width.input.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.messurement_weight.input.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.messurement_length.input.addEventListener("change", () => { saveMetrics(); });
            this.messurement_height.input.addEventListener("change", () => { saveMetrics(); });
            this.messurement_width.input.addEventListener("change", () => { saveMetrics(); });
            this.messurement_weight.input.addEventListener("change", () => { saveMetrics(); });


            this.deliveryInstructions.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.deliveryInstructions.addEventListener("change", () => { this.save(false); });
            this.orderNo.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.orderNo.addEventListener("change", () => { this.save(false); });
            this.referenceNo.addEventListener("keydown", (e) => { enterSubmit(e); });
            this.referenceNo.addEventListener("change", () => { this.save(false); });

            var packagingContainer = this.container.appendChild(document.createElement("div"));
            var carrierContainer = this.container.appendChild(document.createElement("div"));
            var parcelTypeContainer = this.container.appendChild(document.createElement("div"));
            carrierContainer.setAttribute("style", "position:absolute; left:20px; width:69%");
            parcelTypeContainer.setAttribute("style", "position:absolute; right:20px; width:20%");


            this.packaging_dropdown = new SP.DropDown(packagingContainer, "/terminal/img/icon/open-box.png");
            this.carrier_dropdown = new SP.DropDown(carrierContainer, "/terminal/img/icon/truck.png");
            this.parcel_type_dropdown = new SP.DropDown(parcelTypeContainer, null);


            this.packaging_dropdown.add("", "none", true);
            for (let i = 0; i < packagings.length; i++) {
                let p = packagings[i];
                this.packaging_dropdown.add(p.id, p.name, p.active);
            }

            for (let key in customer.deliveryMethods) {
                let m = customer.deliveryMethods[key];
                if (m.isReturn) continue;
                if (m.orderSources.length && !m.orderSources.includes(shipment.order.orderSource)) continue;

                this.carrier_dropdown.add(m.id, m.name, true);
            }

            this.packaging_dropdown.onChange((val: string) => {
                this.setPackaging(val, true);
            });

            this.updateParcelTypes(false);

            this.parcel_type_dropdown.onChange((key: string) => {
                this.setParcelType(key, true);
            });

            this.carrier_dropdown.onChange((key: string) => {
                this.setDeliveryMethod(key, true);
            });

            this.contents.classList.add("contents");
            this.contents.innerHTML = "<span class='header'>" + SP.Localize("word_contents") + "</span>";
            this.container.appendChild(this.contents);

            var instructionContainer = this.container.appendChild(document.createElement("div"));
            instructionContainer.classList.add("package_text_input", "pi_delivery_instructions");
            instructionContainer.appendChild(this.deliveryInstructions);
            this.deliveryInstructions.value = this.shipment.order.deliveryInstructions;
            var instructionsText = instructionContainer.appendChild(document.createElement("span"));
            instructionsText.textContent = "Delivery instructions";

            var orderNoContainer = this.container.appendChild(document.createElement("div"));
            orderNoContainer.classList.add("package_text_input","pi_order_no");
            orderNoContainer.appendChild(this.orderNo);
            this.orderNo.value = this.shipment.order.orderNo;
            if (this.toteInfo.pickSettings?.appendToteNameToOrderNo ?? false) this.orderNo.value += " (" + this.toteInfo.toteName + ")";
            var orderNoText = orderNoContainer.appendChild(document.createElement("span"));
            orderNoText.textContent = "Order";



            var referenceNoContainer = this.container.appendChild(document.createElement("div"));
            referenceNoContainer.classList.add("package_text_input","pi_reference_no");
            referenceNoContainer.appendChild(this.referenceNo);
            this.referenceNo.value = this.shipment.order.referenceNo;
            if (this.toteInfo.pickSettings?.appendToteNameToReference ?? false) this.referenceNo.value += " (" + this.toteInfo.toteName + ")";
            var referenceNoText = referenceNoContainer.appendChild(document.createElement("span"));
            referenceNoText.textContent = "Reference";

            this.print_button.classList.add("grad-green", "button", "print_button");
            this.print_button.innerHTML = SP.Localize("sentance_print_label");
            this.container.appendChild(this.print_button);

            this.print_note_button.classList.add("button", "label", "note");
            this.print_note_button.innerHTML = "🧾";
            this.container.appendChild(this.print_note_button);

            this.label_info.classList.add("label_info");
            this.container.appendChild(this.label_info);

            this.print_button.addEventListener("click", () => {
                this.save(false);
                this.printLabel();
            });

            this.print_note_button.addEventListener("click", async () => {
                this.save(false);
                this.printDeliveryNote();
            });

            new SP.Droppable(this.contents, ["packageItem", "orderItem"], async (type, d) => {
                if (type == "packageItem") {
                    let item = d as PackageItem;
                    if (item.parent == this) return;
                    item.parent.addItem(item.item, item.order_line_id, -1);
                    this.addItem(item.item, item.order_line_id, 1);
                    App_Pack_Order.Instance.updateCounts();
                }

                if (type == "orderItem") {
                    let item = d as OrderItem;
                    this.addItem(item.item, item.order_line_id, 1);
                    App_Pack_Order.Instance.updateCounts();
                }
            });

            this.updateLabelInfo();


        }


        async addItem(item: SP.ItemInfo, order_line_id: string, qty: number, save: boolean = true) {
            if (qty == 0) return;
            var current = this.items[order_line_id];
            if (!current) {
                current = this.items[order_line_id] = new PackageItem(item, 0, order_line_id, this);
                this.contents.appendChild(current.container);
            }

            current.qty += qty;

            if (current.qty <= 0) {
                current.container.remove();
                delete this.items[order_line_id];

            }
            else {
                current.update();
            }


            if (Object.keys(this.items).length === 0) {
                await App_Pack_Order.Instance.removePackage(this);
                return;
            }

            if (save) {
                this.calculateMetrics();
            }

            //rollback if not save
            if (save && !await this.save(true)) {
                await this.addItem(item, order_line_id, -qty, false);
                this.calculateMetrics();
            }
        }

        async save(saveLines: boolean) {

            let lines: { [line_id: string]: number } = null;
            let postData = {
                id: this.id,
                orderId: this.shipment.order.orderId,
                shipmentId: this.shipment.shipmentId,
                fulfillmentLocation: this.toteInfo.pickSettings.fulfillmentLocation,
                width: this.width,
                length: this.length,
                height: this.height,
                weight: this.weight,
                deliveryMethodId: this.deliveryMethodId,
                parcelType: this.parcelType,
                packagingId: this.packaging?.id ?? SP.Guid.Empty,
                deliveryInstructions: this.deliveryInstructions.value,
                orderNo: this.orderNo.value,
                referenceNo: this.referenceNo.value,
                lines: lines
            }
            console.log(postData);



            if (saveLines) {
                postData.lines = {};
                for (let l_id in this.items) {
                    let item = this.items[l_id];
                    postData.lines[l_id] = item.qty;
                }
            }

            var result: any = null;
            if (!this.id) result = await SP.post("/api/v1/package/create", postData);
            else result = await SP.post("/api/v1/package/update", postData);

            if (result.status == 200) {
                if (result.packageId) this.id = result.packageId;
                App_Pack_Order.Instance.readyCheck();
            }
            else {
                await SP.alertX(result.status + ": " + result.msg);
            }


            return true;
        }


        async printLabel() {
            console.log("ParcelType:", this.parcelType);
            if (this.parcelType == null) {
                SP.alertX(SP.Localize("text_please_select_parcel_type"));
                return;

            }


            if (this.trackingNumber) {
                if (!await SP.confirmX(SP.Localize("text_confirm_double_label_print"))) return;
            }

            if (!App_Pack_Order.Instance.allPacked) {
                if (App_Pack_Order.Instance.packedItems > App_Pack_Order.Instance.totalItems && !await SP.confirmX(SP.Localize("text_to_many_items_packed"))) return;
                if (!await SP.confirmX(SP.Localize("text_not_all_items_packed"))) return;
            }

            this.print_button.classList.add("btn_disabled");
            this.print_button.classList.add("btn_disabled_effect");
            if (!App_Settings.terminalSettings.label_printer) {
                SP.alertX(SP.Localize("sentance_please_select_printer"));
                return;
            }


            var result = await SP.get<any>("/api/v1/package/print/" + this.id + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
            console.log("print result", result);
            if (result.status == 200) {
                this.trackingNumber = result.trackingNumber;
                this.updateLabelInfo();
                var last = App_Pack_Order.Instance.readyCheck();
                console.log("updating label with", result.trackingNumber);


                //Print documents
                var result: any = await SP.post("/api/v1/package/printDocuments/" + this.id, {
                    label_printer: App_Settings.terminalSettings.label_printer,
                    etiquette_printer: App_Settings.terminalSettings.etiquette_printer,
                    a4_printer: App_Settings.terminalSettings.a4_printer,
                    print_order_documents: last
                });

                //Print Deliverynote
                if (last && !App_Settings.userSettings.print_delivery_instantly && (App_Pack_Order.Instance.currentShipment.order.printDeliveryNote
                    || (App_Pack_Order.Instance.tote.pickSettings?.forceDeliveryNote ?? false)
                    || (App_Pack_Order.Instance.currentShipment.order.deliveryMethodInfo?.forceDeliveryNote ?? false))) {
                    App_Pack_Order.Instance.printDeliveryNote(true)
                }
            }
            else {
                await SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
            }
            this.print_button.classList.remove("btn_disabled");
        }

        async printDeliveryNote() {
            this.print_note_button.classList.add("disabled");
            if (!App_Settings.terminalSettings.label_printer) {
                SP.alertX(SP.Localize("sentance_please_select_printer"));
                return;
            }

            var result = await SP.get<any>("/api/v1/package/printnote/" + this.id + "?label_printer=" + App_Settings.terminalSettings.label_printer + "&etiquette_printer=" + App_Settings.terminalSettings.etiquette_printer + "&a4_printer=" + App_Settings.terminalSettings.a4_printer);
            console.log("print result", result);
            if (result.status != 200) {
                SP.alertX(result.status + ": " + result.msg + (result.exception ? " - " + result.exception : ""));
            }
            this.print_note_button.classList.remove("disabled");           
        }


        setParcelType(key: string, save: boolean) {
            console.log("setparceltype:" + key);
            this.parcelType = key;
            this.parcel_type_dropdown.value = key;
            if (save) this.save(false);
        }

        setDeliveryMethod(id: string, save: boolean) {
            let dm = this.customer.deliveryMethods[id];
            console.log("setting deliverymethod to", dm);
            this.selectedDeliveryMethod = dm;
            this.deliveryMethodId = id;
            this.carrier_dropdown.value = id;


            this.updateParcelTypes(true);

            if (save) this.save(false);
        }

        updateParcelTypes(reset_to_first:boolean) {
            console.log("Updating parcel types with method: " + this.deliveryMethodId);
            this.parcel_type_dropdown.clear();
            var method = this.customer.deliveryMethods[this.deliveryMethodId];
            var d

            var parcelTypes = method != null ? method.parcelTypes.filter(pt => pt.enabled) : [];

            console.log("SETTINGS PARCELTYPES", parcelTypes);

            var def = parcelTypes[0]?.code ?? null;

            if (parcelTypes.length > 1) {
                this.parcel_type_dropdown.add(null, "Select Type".toString(), true);
                def = null;
                
            }
            parcelTypes.forEach(pt => { this.parcel_type_dropdown.add(pt.code, pt.name, true); });

            if (reset_to_first) this.setParcelType(def, false);
            console.log("Updating Parcel Types");
        };


        setPackaging(val: string, save: boolean) {

            var id = val ?? SP.Guid.Empty;
            let p = packagings.filter(p => p.id == id)[0];
            console.log("setting packaging to", p);

            this.packaging = p;
            this.packaging_dropdown.value = id;
            this.calculateMetrics();

            if (save) this.save(false);
        }

        calculateMetrics() {
            this.before_height = this.height;
            this.before_length = this.length;
            this.before_weight = this.weight;
            this.before_width = this.width;

            let weight = 0;
            let height = 0;
            let length = 0;
            let width = 0;

            if (this.packaging != null) {
                weight += this.packaging.weight;
                height = this.packaging.height;
                length = this.packaging.width;
                width = this.packaging.debth;
            }

            for (let line_id in this.items) {
                let item = this.items[line_id];
                let w = item.item.warehouseWeight ? item.item.warehouseWeight : item.item.weight;
                weight += w * item.qty;
            }

            this.width = width;
            this.length = length;
            this.height = height;
            this.weight = weight;

            this.updateDeliveryMethods();
            this.renderInputData();
        }


        renderInputData() {
            this.messurement_weight.input.value = this.weight.toString();
            this.messurement_height.input.value = this.height.toString();
            this.messurement_length.input.value = this.length.toString();
            this.messurement_width.input.value = this.width.toString();
            this.carrier_dropdown.value = this.deliveryMethodId;
            this.packaging_dropdown.value = this.packaging?.id ?? "";
        }

        saveMetricsFromInputs() {
            this.length = parseInt(this.messurement_length.input.value);
            this.height = parseInt(this.messurement_height.input.value);
            this.width = parseInt(this.messurement_width.input.value);
            this.weight = parseInt(this.messurement_weight.input.value);
        }

  
        updateDeliveryMethods() {
            var dimensions = [this.length, this.height, this.width].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            var length = dimensions[2];
            var circumferenceLength = dimensions[0] * 2 + dimensions[1] * 2 + dimensions[2];



            var weight = this.weight;



            for (let key in this.customer.deliveryMethods) {
                let m = this.customer.deliveryMethods[key];
                let dd = this.carrier_dropdown.item_dictionary[m.id];

                if (!dd) continue;


                var destinationCountry = this.shipment.order.recipient.country.toUpperCase();
                var localPrices = m.prices[destinationCountry]

                if (!localPrices) {
                    dd.enabled = false;
                    continue;
                }


                

                let remaining = localPrices.filter(l =>
                    (l.maxCircumferenceLength == 0 || l.maxCircumferenceLength >= circumferenceLength) &&
                    (l.maxLength == 0 || l.maxLength >= length) &&
                    (l.maxWeight == 0 || l.maxWeight >= weight)
                );


                if (!remaining.length) {
                    dd.enabled = false;
                    continue;
                }

                dd.enabled = true;

            }

        }

        updateLabelInfo() {
            if (!this.trackingNumber) {
                this.label_info.innerHTML = SP.Localize("sentance_no_label_generated") + "!";
            }
            else {
                this.label_info.innerHTML = this.trackingNumber;
            }

        }

    }

    export class ItemBase {
        container = document.createElement("div");


        item: SP.ItemInfo;

        constructor(item: SP.ItemInfo) {
            this.item = item;

            this.container.classList.add("order_item");
            this.container.innerHTML += `<div class="image"><img src="${item.imageUrl}" /></div>`;
            this.container.innerHTML += `<div class="sku ellipsis"><b>${item.sku}</b> - ${(item.manufacturerName + item.modelNo).trim()}`;
            this.container.innerHTML += `<div class="name ellipsis">${item.description}</div>`;
            this.container.innerHTML += `<div class="barcodes ellipsis">${item.barcodes.join(", ")}</div>`;
        }
    }




    export class OrderItem extends ItemBase {
        label = document.createElement("div");
        label_current = document.createElement("span");
        label_max = document.createElement("span");
        order_line_id = "";
        packed_qty = 0;
        max_qty = 0;

        constructor(sl: SP.ShipmentLineInfo) {
            super(sl.orderLine.itemInfo);
            this.max_qty = sl.qty;
            this.order_line_id = sl.orderLine.id;
            this.packed_qty = 0;

            this.container.appendChild(this.label);
            this.label.classList.add("label", "label-warning");

            this.label.appendChild(this.label_current);
            this.label_current.classList.add("current");
            this.label.appendChild(this.label_max);

            this.label_current.innerHTML = "0";
            this.label_max.innerHTML = " / " + this.max_qty;
      

            let dblClick = async () => {
                console.log("dbl");
                if (!App_Pack_Order.Instance.activePackage)
                    App_Pack_Order.Instance.addPackage();
                await App_Pack_Order.Instance.activePackage.addItem(this.item, this.order_line_id, this.max_qty - this.packed_qty, true);
                App_Pack_Order.Instance.updateCounts();
            };
            

            if (sl.orderLine.itemInfo.warehouseNotificationPacker) {
                var button = document.createElement("div");
                button.innerHTML = "ℹ️";
                button.classList.add("notification-button");
                button.addEventListener("click", () => {
                    new SP.DismissInfo("Warehouse Notification (Item:" + sl.orderLine.itemInfo.sku + ")", sl.orderLine.itemInfo.warehouseNotificationPacker);
                });
                button.click();
                this.container.appendChild(button);
            }


            this.container.addEventListener("dblclick", dblClick);


            //let touched: number = 0;
            //this.container.addEventListener("touchstart", async() => {
            //    let now = performance.now();
            //    if (now - touched < 400) {
            //        touched = 0;
            //        console.log("DoucbleClick touch");
            //        await dblClick();
            //    }
            //    else
            //        touched = now;

            //});

            new SP.Draggable(this.container, "orderItem", this);

        }

        update() {


            this.label_current.innerHTML = this.packed_qty.toString();

            if (this.packed_qty == this.max_qty) {
                this.label.classList.remove("label-warning");
            }
            else {
                this.label.classList.add("label-warning");

            }
        }
    }

    export class PackageItem extends ItemBase {
        label = document.createElement("div");
        qty = 0;
        parent: Package;
        order_line_id: string;

        constructor(item: SP.ItemInfo, qty: number, order_line_id: string, parent: Package) {
            super(item);
            this.qty = qty;
            this.order_line_id = order_line_id;
            this.parent = parent;
            this.container.appendChild(this.label);
            this.label.classList.add("label");
            this.label.innerHTML = this.qty.toString();

            let deleteButton = this.container.appendChild(document.createElement("div"));
            deleteButton.innerHTML = '<i class="fas fa-trash"></i>';
            deleteButton.classList.add("delete");

            let deleteFn = async () => {
                await this.parent.addItem(this.item, this.order_line_id, - this.qty, true);
                App_Pack_Order.Instance.updateCounts();
            };

            deleteButton.addEventListener("click", deleteFn);
            new SP.Draggable(this.container, "packageItem", this);

        }

        update() {
            this.label.innerHTML = this.qty.toString();
        }
    }

    export class WeighItem extends ItemBase {
        input = document.createElement("input");
        unit = document.createElement("span");
        constructor(item: SP.ItemInfo) {
            super(item);
            let weight = item.warehouseWeight ? item.warehouseWeight : item.weight;
            this.input.type = "number";
            this.input.classList.add("weight_input");
            this.unit.classList.add("weight_unit");
            this.unit.innerHTML = "g";
            this.input.value = weight.toString();
            this.container.appendChild(this.input);
            this.container.appendChild(this.unit);
            this.input.onfocus = () => {
                this.input.select();
            };

        }
    }




    RegisterApp("app_pack_order", App_Pack_Order);

}